// frontend/src/services/authService.js
import axiosInstance from './axiosConfig';

// In your service file

/**
 * Sends a request to initiate password reset.
 * @param {object} usernameData - Object containing the username, e.g., { username: "user123" }
 */
export const requestPasswordReset = async (usernameData) => {
  try {
    const response = await axiosInstance.post('/auth/forgot-password', usernameData);
    return response.data; // Backend returns a generic success message
  } catch (error) {
    console.error('Error in requestPasswordReset service:', error.response?.data || error.message);
    // The backend sends a generic success message even for non-existent users for security,
    // so actual errors here might be network issues or server errors (500).
    // Let the component handle displaying the generic message.
    throw error.response?.data || new Error('Failed to request password reset.');
  }
};

// In your service file

/**
 * Sends the new password along with the reset token and username.
 * @param {object} resetData - Object containing { token, username, newPassword }
 */
export const resetPassword = async (resetData) => {
  try {
    const response = await axiosInstance.post('/auth/reset-password', resetData);
    return response.data; // Backend returns a success message
  } catch (error) {
    console.error('Error in resetPassword service:', error.response?.data || error.message);
    // Errors here could be invalid/expired token, validation issues with new password, etc.
    throw error.response?.data || new Error('Failed to reset password.');
  }
};